(() => {
  const root = document.documentElement;

  if (root.dataset.rvRespectReducedMotion !== 'true') return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateAutoplayMedia = () => {
    if (!reducedMotion.matches) return;

    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
      video.controls = true;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAutoplayMedia, { once: true });
  } else {
    updateAutoplayMedia();
  }

  reducedMotion.addEventListener?.('change', updateAutoplayMedia);
})();
